// extracted by mini-css-extract-plugin
export var actionText = "_rp-4";
export var container = "_rp-0";
export var leftSection = "_rp-1";
export var rightSection = "_rp-2";
export var settingsButton = "_rp-6";
export var settingsIcon = "_rp-7";
export var shortcut = "_rp-5";
export var shortcutGroup = "_rp-3";